import { Grid, Link } from '@mui/material';

const DescriptionForm = () => <div>
    <Grid container spacing={2} marginTop="10px">
        <Grid item xs={0} sm={1} md={1}></Grid>
        <Grid item xs={12} sm={10} md={10} style={{margin: '15px', padding: '15px', border: '1px solid black'}}>
			<p>Реєстрація на онлайн курс по бойовому застосуванню дронів, рацій, Starlink та інших технологій від проєкту <Link href='https://www.victory-drones.com/' target="_blank">Victory Drones</Link>.</p>
			<p>Курс складається з відеолекцій та підбірок корисних навчальних матеріалів. Інформація періодично оновлюється та актуалізується. Більше про <Link href='https://prometheus.org.ua/prometheus-free/technology-in-wartime/' target="_blank">програму курсу тут</Link>.</p>

			<p>Навчання доступне виключно для чинних військовослужбовців, прикордонників, рятувальників, поліцейських, медиків тощо, – за офіційним запитом від вашої структури.</p>

			<p>Курс буде доступний після реєстрації в особистому кабінеті на платформі <Link href='https://prometheus.org.ua/' target="_blank">Prometheus</Link>.</p>

			<p>Після проходження онлайн курсу запрошуємо долучитися до комплексної практичної підготовки за напрямами: аеророзвідка, FPV, спеціалізоване військове програмне забезпечення тощо. <Link href='https://docs.google.com/forms/d/e/1FAIpQLSfZTeTu5kvhMwGwtEvoaT8w5iFFoaorH1ITLPRHEnZ7eblYOg/viewform' target="_blank">Заповнити заявку тут.</Link><br/>В якості альтернативи, для проходження практики можна звернутися до однієї з дружніх шкіл. Список <Link href='https://docs.google.com/spreadsheets/d/123rHsqUFn4RSiID-i2_bLhGzqlsgWZgY/edit?gid=19494152#gid=19494152' target="_blank">шкіл тут</Link>.</p>

			<p><i>Проєкт Victory Drones реалізується громадською організацією “Центр Підтримки Аеророзвідки” спільно з благодійним фондом Dignitas.</i></p>

        </Grid>

    </Grid>

</div>;


export default DescriptionForm;
